import b from "keen-slider";
const g = [!0, "true", 1, "1", "yes", "on"], k = [!1, "false", 0, "0", "no", "off", null, void 0];
function y(i) {
  return typeof i == "string" && (i = i.toLowerCase()), g.indexOf(i) >= 0 ? !0 : k.indexOf(i) >= 0 ? !1 : null;
}
function h(i) {
  return typeof i == "string" && (i = i.toLowerCase()), g.indexOf(i) >= 0;
}
function m(i, e, n) {
  let t;
  return typeof e == "function" ? (t = document, n = e) : t = e || document, typeof n == "function" ? Array.from(t.querySelectorAll(i), n) : Array.from(t.querySelectorAll(i));
}
function L(i) {
  if (typeof i > "u")
    return new Promise((e) => L(e.bind(null, null)));
  document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", i) : i.call(document);
}
function x(i, e, n) {
  return (t) => {
    let o, a = !1;
    function d() {
      clearTimeout(o);
    }
    function u() {
      clearTimeout(o), !a && (o = setTimeout(() => {
        t.next();
      }, n.autoplay * 1e3));
    }
    t.on("created", () => {
      t.container.addEventListener("mouseover", () => {
        a = !0, d();
      }), t.container.addEventListener("mouseout", () => {
        a = !1, u();
      }), u();
    }), t.on("dragStarted", d), t.on("animationEnded", u), t.on("updated", u);
  };
}
function E(i, e, n) {
  return (t) => {
    function o(s, r) {
      if (r && (r.preventDefault(), r.stopPropagation()), s.disabled || s.classList.contains("disabled"))
        return;
      let c = s.dataset.keenControl || "";
      c == "next" ? this.next() : c == "prev" ? this.prev() : isNaN(parseInt(c)) || this.moveToIdx(parseInt(c) - 1);
    }
    function a(s) {
      s.forEach((r) => {
        r.addEventListener("click", o.bind(t, r));
      });
    }
    function d(s) {
      s.forEach((r) => {
        r.removeEventListener("click", o.bind(t, r));
      });
    }
    function u(s) {
      s.forEach((r) => {
        let c = r.dataset.keenControl || "";
        if (c == "next") {
          if (e.loop)
            return;
          t.track.details.rel === 0 ? (r.disabled = !0, r.classList.add("disabled")) : (r.disabled = !1, r.classList.remove("disabled"));
        } else if (c == "prev") {
          if (e.loop)
            return;
          t.track.details.rel === t.slides.length - 1 ? (r.disabled = !0, r.classList.add("disabled")) : (r.disabled = !1, r.classList.remove("disabled"));
        } else
          isNaN(parseInt(c)) || (parseInt(c) - 1 === t.track.details.rel ? (r.classList.add("current"), r.classList.add("active")) : (r.classList.remove("current"), r.classList.remove("active")));
      });
    }
    function l() {
      var r;
      let s = typeof n.indicators == "string" ? document.querySelector(n.indicators) : (r = i.parentElement) == null ? void 0 : r.querySelector('[data-keen-attach="indicators"]');
      if (!(!(s instanceof HTMLElement) || (s.dataset.keenAttach || "") != "indicators")) {
        s.innerHTML = "";
        for (let c = 1; c <= t.slides.length; c++) {
          let p = document.createElement("button");
          p.type = "button", p.className = "keen-indicator", p.dataset.keenControl = c.toString(), p.innerHTML = '<span class="indicator"></span>', s.append(p);
        }
      }
    }
    function f() {
      let s = [];
      return n.controls != !1 && s.push(
        ...typeof n.controls == "string" ? m(`${n.controls} button[data-keen-control]`) : Array.from(i.parentElement.querySelectorAll("button[data-keen-control]"))
      ), n.indicators != !1 && s.push(
        ...typeof n.indicators == "string" ? m(`${n.indicators} button[data-keen-control]`) : Array.from(i.parentElement.querySelectorAll("button[data-keen-control]"))
      ), s.filter((r, c, p) => p.indexOf(r) === c);
    }
    t.on("created", () => {
      n.indicators && l();
      const s = f();
      a(s), u(s);
    }), t.on("updated", () => {
      n.indicators && l();
      const s = f();
      u(s);
    }), t.on("optionsChanged", () => {
      n.indicators && l();
      const s = f();
      u(s);
    }), t.on("slideChanged", () => {
      const s = f();
      u(s);
    }), t.on("destroyed", () => {
      const s = f();
      d(s), u(s);
    });
  };
}
function v(i, e = 200, n = 100) {
  return new Promise((t, o) => {
    let a = 0, d = async () => {
      let u = !1;
      try {
        u = await i();
      } catch (l) {
        o(l);
      }
      a++, u ? t(null) : a <= n && setTimeout(d, e);
    };
    d();
  });
}
function S(i, e, n) {
  return e.loop = !0, e.defaultAnimation = {
    duration: 2e3
  }, e.renderMode = "custom", (t) => {
    t.on("created", async (o) => {
      if (!(o.slides.length > 0 && o.slides[0].querySelector("img")))
        return;
      let a = o.slides[0].querySelector("img");
      await v(((d) => d.offsetHeight > 0).bind(null, a)), o.slides.map((d) => {
        d.style.height = `${o.container.offsetHeight}px`;
      }), o.container.style.height = `${o.container.offsetHeight}px`, o.container.classList.add("created"), o.update();
    }), t.on("detailsChanged", (o) => {
      o.slides.forEach((a, d) => {
        a.style.opacity = o.track.details.slides[d].portion.toString();
      });
    }), t.on("destroyed", (o) => {
      o.container.classList.remove("created");
    });
  };
}
function w(i, e, n) {
  const o = {
    duration: Math.max(n.autoplay > 0 ? n.autoplay * 1e3 : 5e3, 5e3),
    easing: (a) => a
  };
  return e.loop = !0, e.defaultAnimation = { ...o }, e.renderMode = "performance", (a) => {
    function d() {
      a.animator.stop();
    }
    function u() {
      a.moveToIdx(a.track.details.abs + a.slides.length, !0, o);
    }
    a.on("created", async (l) => {
      l.moveToIdx(l.slides.length, !0, o), l.container.addEventListener("mouseover", d), l.container.addEventListener("mouseout", u);
    }), a.on("updated", async (l) => {
      l.moveToIdx(l.track.details.abs + l.slides.length, !0, o);
    }), a.on("animationEnded", async (l) => {
      l.moveToIdx(l.track.details.abs + l.slides.length, !0, o);
    }), a.on("destroyed", async (l) => {
      l.container.removeEventListener("mouseover", d), l.container.removeEventListener("mouseout", u);
    });
  };
}
function q(i, e, n) {
  return e.slides = {
    perView: 1.5,
    spacing: 15,
    origin: "center"
  }, e.breakpoints = {
    "(min-width: 768px)": {
      slides: {
        perView: Math.max(Math.ceil(n.amount / 3), 1.5),
        spacing: 20
      }
    },
    "(min-width: 1024px)": {
      slides: {
        perView: Math.max(Math.ceil(n.amount / 3), 2),
        spacing: 30
      }
    },
    "(min-width: 1200px)": {
      slides: {
        perView: n.amount,
        spacing: 50
      }
    }
  }, (t) => {
  };
}
function A(i, e, n) {
  return e.loop = !0, (t) => {
    t.on("created", async (o) => {
      if (!(o.slides.length > 0 && o.slides[0].querySelector("img")))
        return;
      let a = o.slides[0].querySelector("img");
      await v(((d) => d.offsetHeight > 0).bind(null, a)), o.slides.map((d) => {
        if (d.style.height = `${o.container.offsetHeight}px`, d.children.length > 1 || !d.children[0].classList.contains("slide-zoom")) {
          const u = document.createElement("div");
          u.className = "slide-zoom", u.append(...Array.from(d.childNodes)), d.append(u);
        }
      }), o.container.style.height = `${o.container.offsetHeight}px`, o.container.classList.add("created"), o.update();
    }), t.on("detailsChanged", (o) => {
      o.slides.forEach((a, d) => {
        if (!a.querySelector(".slide-zoom"))
          return;
        const u = 0.7, f = `scale(${1 - (u - u * o.track.details.slides[d].portion)})`;
        a.querySelector(".slide-zoom").style.transform = f;
      });
    }), t.on("destroyed", (o) => {
      o.container.classList.remove("created");
    });
  };
}
function C(i) {
  const e = {};
  for (let [n, t] of Object.entries(i.dataset))
    if (n.startsWith("keen")) {
      if (typeof t > "u" && (t = "1"), n = n.slice(4, 5).toLowerCase() + n.slice(5), n = n.replace(/([A-Z])/g, (o, a) => "-" + a.toLowerCase()), n == "slider" && (t = !0), ["controls", "indicators"].indexOf(n) >= 0 && (t = t.trim().length == 0 ? "true" : t, y(t) && (t = h(t))), ["drag", "keyboard", "loop"].indexOf(n) >= 0)
        if (t = t.trim().length == 0 ? "true" : t, y(t))
          t = h(t);
        else
          continue;
      (n == "autoplay" || n == "amount") && (t = parseInt(t), isNaN(t)) || n == "transition" && ["slide", "fade", "zoom"].indexOf(t) < 0 || (e[n] = t);
    }
  return e.slider = typeof e.slider > "u" ? !0 : e.slider, e.style = typeof e.style > "u" ? "default" : e.style, e.controls = typeof e.controls > "u" ? !1 : e.controls, e.indicators = typeof e.indicators > "u" ? !1 : e.indicators, e.autoplay = typeof e.autoplay > "u" ? 0 : e.autoplay, e.transition = typeof e.transition > "u" ? "slide" : e.transition, e.drag = typeof e.drag > "u" ? !0 : e.drag, e.keyboard = typeof e.keyboard > "u" ? !0 : e.keyboard, e.loop = typeof e.loop > "u" ? !0 : e.loop, e.amount = typeof e.amount > "u" ? 1 : e.amount, e;
}
function M(i) {
  const e = C(i), n = {
    drag: e.drag,
    loop: e.loop
  }, t = [];
  e.amount && e.amount > 1 && t.push(q(i, n, e)), e.autoplay && e.style != "marquee" && t.push(x(i, n, e)), e.style == "marquee" && t.push(w(i, n, e)), e.style != "marquee" && e.transition == "fade" ? t.push(S(i, n)) : e.style != "marquee" && e.transition == "zoom" && t.push(A(i, n)), (e.controls || e.indicators) && t.push(E(i, n, e)), t.push((a) => {
    a.on("created", () => {
      a.container.classList.add(`keen-style--${e.style}`), a.container.classList.add(`keen-transition--${e.transition}`);
    });
  });
  const o = new b(i, { ...n }, [...t]);
  return i.__keen_slider = o, o;
}
async function I() {
  await L(), m("[data-keen-slider]", (i) => M(i));
}
export {
  M as initKeenSlider,
  I as invokeKeenSlider
};
